<template>
  <span class="module-container">
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 lg12 mb-3>
          <v-expansion-panel popout>
            <v-expansion-panel-content v-for="module in modules_all">
              <template v-slot:header>
                <div @click.prevent="SwResource(module.id, module.lessons)">{{module.name}}</div>
              </template>
              <v-card>
                <v-card-text>
                  <lessons :lessons="module.lessons"></lessons>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-layout>
    </v-container>
  </span>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import Lessons from "./LessonResource.vue";
export default {
  name: "modulesInCourse",
  components: {
    Lessons
  },
  created() {},
  data() {
    return {
      showResource: true
    };
  },
  computed: {
    ...mapState,
    ...mapGetters(
      {
        modules_all: "course/modules_all", 
      today: "today"
      })
  },
  methods: {
    SwResource: function(id, lessons) {
        this.$store.commit('course/module_selected', id);
        this.$store.commit('all_lessond', lessons[0].resources)
    },

  },

};
</script>
<style>
.module-container {
  display: flex;
  flex-direction: column;
}
.item-module-name {
  width: 100%;
  display: flex;
  padding: 10px 10px;
  font-size: 1.2rem;
  cursor: pointer;
  background-color: #f8fbfc;
  border-top: 1px solid #e6f2f5;
  border-bottom: 1px solid #e6f2f5;
}
.item-module-name:hover {
  background-color: #e6f2f5;
}
</style>